import {documentToPlainTextString} from '@contentful/rich-text-plain-text-renderer'

import {t} from '../../../lib/utils/localization'
import type {RichText} from '../../../schemas/contentful/richText'

export function getInfoTooltipAriaLabel(description: RichText) {
  const feature = documentToPlainTextString(description).trim()

  return feature
    ? t('More information about {feature}').replace('{feature}', feature)
    : t('More information about this feature')
}
